import Cookies from 'js-cookie';
import * as React from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { useWebform } from 'src/hooks/useWebform';
import NewsletterSignUpForm from '../components/forms/NewsletterSignUpForm';
import NewsletterSignupModal from '../components/forms/components/newslettersignup/NewsletterSignupModal';

interface StorageNewsletterSignupFormProps {
  node?: IStorageNewsletterSignupForm;
}

const StorageNewsletterSignUpForm = ({ node: data }: StorageNewsletterSignupFormProps) => {
  const { getFieldDataByName } = useWebform(data?.relationships?.form);

  const newsletterSignUpCookie = Cookies.get('newsletterSignUp');

  const handleModalSubmit = () => {
    Cookies.set('newsletterSignUp', 'Submitted', { expires: 90 });
    Cookies.set('newsletterSignUp', 'Submitted', {
      expires: 90,
      secure: true,
      sameSite: 'Lax',
      path: '/',
    });
  };

  const heading = (
    <>
      <h2 className="text-left">{data?.title}</h2>

      <div className="text-left mb-5">{data?.description}</div>
    </>
  );

  if (!data?.modal) {
    return (
      <Container className="py-5">
        <Row className="justify-content-md-center">
          <Col md="8">
            {heading}

            <NewsletterSignUpForm
              getFieldDataByName={getFieldDataByName}
              langcode={data?.langcode || 'en'}
            />
          </Col>
        </Row>
      </Container>
    );
  }

  if (data?.modal && !newsletterSignUpCookie) {
    return (
      <NewsletterSignupModal modalDelay={data?.modalDelay}>
        {heading}

        <NewsletterSignUpForm
          getFieldDataByName={getFieldDataByName}
          langcode={data?.langcode || 'en'}
          modal
          submitCallback={handleModalSubmit}
        />
      </NewsletterSignupModal>
    );
  }

  return null;
};

export default StorageNewsletterSignUpForm;
